import ProjectDocument from "../../model/document/ProjectDocument";
import StoreyDocument from "../../model/document/StoreyDocument";
import { UUID } from "../../utils/typeDefinitions";
import IBimVisualizerApiProvider from "../bimVisualizerApi/IBimVisualizerApiProvider";
import ApiProjectDocumentProvider from "./ApiProjectDocumentProvider";
import Document from "../../model/document/Document";
import IContextDocument from "../../model/document/IContextDocument";

class ApiStoreyDocumentProvider extends ApiProjectDocumentProvider {
    private storeyUuid: UUID;
    constructor(projectUuid: UUID, storeyUuid: UUID, apiProvider: IBimVisualizerApiProvider ) {
        super(projectUuid, apiProvider);
        this.storeyUuid = storeyUuid;
    }

    getEntityId(): UUID {
        return this.storeyUuid;
    }
    
    toContextDocument(doc: Document): IContextDocument {
        return new StoreyDocument(this.projectUuid, this.storeyUuid, doc);
    }

    async createInitialDocument(): Promise<IContextDocument> {
        const newDoc = new StoreyDocument(  this.projectUuid, this.storeyUuid,  
                                            new Document(`Document for storey ${this.storeyUuid}`));        
        newDoc.document.documentUuid = await this.apiProvider.addProjectDocument(newDoc.projectUuid, newDoc.storeyId, newDoc.document.name) ?? "";
        return newDoc;
    }   
}

export default ApiStoreyDocumentProvider;
